export default "__VITE_ASSET__5a2ffe3a__$_?component__"